import dayjs from 'dayjs'
import { LoaderFunction, redirect } from 'react-router-dom'

import { FormattedSlot, Slot } from '@/apiTypes.ts'
import { useAppointmentStore } from '@/store.ts'
import { fetchFromApi } from '@/utils/fetchFromApi.ts'

interface LoaderData {
  slot?: FormattedSlot
  loadTime?: number
  error?: string
}

const loader: LoaderFunction<LoaderData> = async (): Promise<
  LoaderData | Response | null
> => {
  const {
    appointmentType,
    defaultLocationId,
    setError,
    setSelectedSlot,
    setSlots,
  } = useAppointmentStore.getState()

  if (!defaultLocationId || !appointmentType) {
    return null
  }

  const startTime = Date.now()
  try {
    const response = await fetchFromApi(
      `slots?type=${appointmentType}&location=${defaultLocationId}`,
    )

    if (!response.ok) {
      // Check for timeout error
      if (response.status === 504) {
        const errorData = await response.json()
        if (errorData.error === 'TIMEFF_TIMEOUT') {
          setError('timeffTimeoutXpert')
          return redirect('/error')
        }
      }
      setError('internalServerError')
      return redirect('/error')
    }

    const slots: Slot[] = await response.json()

    if (slots.length === 0) {
      return redirect('/referral/manual-booking/select-clinic')
    }

    const formattedSlots: FormattedSlot[] = slots.map((slot) => ({
      ...slot,
      end: dayjs(slot.end),
      start: dayjs(slot.start),
    }))

    setSlots(formattedSlots)
    setSelectedSlot(formattedSlots[0])
    return { loadTime: Date.now() - startTime, slot: formattedSlots[0] }
  } catch (error) {
    console.error('Error fetching appointment slots:', error)
    return {
      error:
        error instanceof Error ? error.message : 'An unknown error occurred',
    }
  }
}

export type { LoaderData }
export { loader }
